// @flow
import React from "react";
import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import {
  COMPANY__CONTACT_PERSON_EMAIL,
  COMPANY__CONTACT_PERSON_PHONE_NUMBER,
  COMPANY__CONTACT_PERSON_GENDER,
  COMPANY__CONTACT_PERSON_FIRST_NAME,
  COMPANY__CONTACT_PERSON_LAST_NAME
} from "./formFields";

import { generateInitialValues } from "../../utils/helpers";
import { mapGender } from "./mappers";

type CreatorProps = {
  initialValues: {
    gender?: string,
    email: string,
    firstName: string,
    lastName: string,
    phoneNumber: string
  }
};

const Creator = ({ initialValues }: CreatorProps) => {
  const contactPerson = generateInitialValues(initialValues);

  return (
    <Section title="Kundendetails" reducedMargin numbered>
      <EditableForm initialValues={contactPerson} isLocked>
        <FormRow separator>
          <EditableField
            fieldControlProps={{
              name: COMPANY__CONTACT_PERSON_GENDER,
              caption: () => "Anrede"
            }}
            displayValue={mapGender}
          />
          <EditableField
            fieldControlProps={{
              name: COMPANY__CONTACT_PERSON_FIRST_NAME,
              caption: () => "Vorname"
            }}
          />
          <EditableField
            fieldControlProps={{
              name: COMPANY__CONTACT_PERSON_LAST_NAME,
              caption: () => "Nachname"
            }}
          />
        </FormRow>
        <FormRow>
          <EditableField
            fieldControlProps={{
              name: COMPANY__CONTACT_PERSON_EMAIL,
              caption: () => "E-Mail"
            }}
          />
          <EditableField
            fieldControlProps={{
              name: COMPANY__CONTACT_PERSON_PHONE_NUMBER,
              caption: () => "Telefonnummer"
            }}
          />
          <div />
        </FormRow>
      </EditableForm>
    </Section>
  );
};

export default Creator;
